import { motion } from "framer-motion";
import { DIY_COMPARISON } from "@/data/content";
import { SectionEyebrow } from "@/components/Marquee";

export default function WhyNotDIY() {
  return (
    <section id="why-not-diy" className="relative py-20 md:py-28 bg-[#0A0A0F]" data-testid="why-not-diy-section">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <SectionEyebrow testId="why-not-diy-eyebrow">The Honest Question</SectionEyebrow>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: [0.8, 0, 0.2, 1] }}
          className="mt-6 font-serif text-white text-5xl sm:text-6xl md:text-7xl leading-[0.98] tracking-tight max-w-4xl"
        >
          "Can't I just <span className="italic gradient-text">negotiate myself?"</span>
        </motion.h2>
        <p className="mt-6 text-silver/70 max-w-2xl leading-relaxed text-lg">
          Of course you can. But the dealer does this every day. The incentives simply aren't aligned — you deserve
          independent representation.
        </p>

        <div className="mt-14 rounded-3xl border border-white/10 bg-surface overflow-hidden max-w-2xl">
          <div className="grid grid-cols-2 text-sm">
            <div className="p-4 md:p-5 border-r border-b border-white/5 text-silver/50 uppercase tracking-widest text-xs">You</div>
            <div className="p-4 md:p-5 border-b border-white/5 text-silver/50 uppercase tracking-widest text-xs">Dealership</div>
          </div>
          {DIY_COMPARISON.map((row, i) => (
            <div key={i} className="grid grid-cols-2 text-sm border-b border-white/5 last:border-b-0">
              <div className="p-4 md:p-5 border-r border-white/5 text-silver/80">{row.you}</div>
              <div className="p-4 md:p-5 text-silver/80">{row.dealer}</div>
            </div>
          ))}
        </div>

        <p className="mt-10 font-serif text-2xl md:text-3xl text-white/90 max-w-2xl leading-snug">
          You can negotiate. <span className="italic gradient-text">We're here so you don't have to.</span>
        </p>
      </div>
    </section>
  );
}
